import React, { useState } from "react";
import MPHomeFirstBlock from "./BarberMainPageComps/MPHomeFirstBlock";
import MPHomeShowImages from "./BarberMainPageComps/MPHomeShowImages";
import MPHomeBookApp from "./BarberMainPageComps/MPHomeBookApp";
import MPHomeModalMakeApp from "./BarberMainPageComps/MPHomeModalMakeApp";
import { useAppContext } from "../AppContext";
import { useTranslation } from "react-i18next";

export default function MPHome() {
  const { t, i18n } = useTranslation();

  const {
    OpenDrawer,
    setOpenDrawer,
    setAllApps,
    Loading,
    setLoading,
    setChoosedDate,
    setChoosedApps,
    AllData,
    setAllData,
    setUser,
    User,
    setAppContextLoading,
    AppContextLoading,
    OtherBarbers,
    setOtherBarbers,
    refreshDataCallback,
    setValue,
    value,
    AllowUsersBookApp,
    setAllowUsersBookApp,
    Lang,
    setLang,
  } = useAppContext();
  const lang = JSON.parse(localStorage.getItem("lang"));
  const [Choosing, setChoosing] = useState(lang);
  const [showDownloadModal, setShowDownloadModal] = useState(false);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  // Function to render star rating
  const renderStars = (rating) => {
    return (
      <div style={{ display: "flex", gap: "4px" }}>
        {[1, 2, 3, 4, 5].map((star) => (
          <svg
            key={star}
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill={star <= rating ? "#FCD34D" : "#E5E7EB"}
            stroke={star <= rating ? "#F59E0B" : "#D1D5DB"}
            strokeWidth="1"
          >
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
          </svg>
        ))}
      </div>
    );
  };

  // Calculate average rating
  const calculateAverageRating = () => {
    if (!AllData?.allReviews || AllData.allReviews.length === 0) return 0;
    const sum = AllData.allReviews.reduce(
      (acc, review) => acc + review.rating,
      0
    );
    return (sum / AllData.allReviews.length).toFixed(1);
  };

  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        flexDirection: "column",
        backgroundColor: "#f5f7fa",
        minHeight: "100vh",
        position: "relative",
      }}
    >
      {/* Decorative background elements */}
      <div
        style={{
          position: "fixed",
          top: "-10%",
          right: "-5%",
          width: "40%",
          height: "40%",
          background:
            "radial-gradient(circle, rgba(102,126,234,0.08) 0%, transparent 70%)",
          borderRadius: "50%",
          pointerEvents: "none",
          zIndex: 0,
        }}
      />
      <div
        style={{
          position: "fixed",
          bottom: "10%",
          left: "-5%",
          width: "35%",
          height: "35%",
          background:
            "radial-gradient(circle, rgba(118,75,162,0.06) 0%, transparent 70%)",
          borderRadius: "50%",
          pointerEvents: "none",
          zIndex: 0,
        }}
      />

      {/* Download App Modal - FOR BUSINESS OWNERS */}
      {showDownloadModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 10000,
            padding: "16px",
            backdropFilter: "blur(4px)",
          }}
          onClick={() => setShowDownloadModal(false)}
        >
          <div
            style={{
              backgroundColor: "#ffffff",
              borderRadius: "24px",
              padding: "40px 32px",
              maxWidth: "500px",
              width: "100%",
              boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
              position: "relative",
              animation: "slideUp 0.3s ease-out",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              onClick={() => setShowDownloadModal(false)}
              style={{
                position: "absolute",
                top: "16px",
                right: "16px",
                width: "36px",
                height: "36px",
                borderRadius: "50%",
                border: "none",
                backgroundColor: "#f3f4f6",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                transition: "all 0.2s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#e5e7eb";
                e.currentTarget.style.transform = "rotate(90deg)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#f3f4f6";
                e.currentTarget.style.transform = "rotate(0deg)";
              }}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#6b7280"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>

            {/* App Icon with Business Badge */}
            <div
              style={{
                width: "100px",
                height: "100px",
                margin: "0 auto 24px",
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                borderRadius: "24px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 10px 30px rgba(102, 126, 234, 0.3)",
                position: "relative",
              }}
            >
              <svg
                width="50"
                height="50"
                viewBox="0 0 24 24"
                fill="none"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
                <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
              </svg>
              {/* Business Badge */}
              <div
                style={{
                  position: "absolute",
                  bottom: "-8px",
                  right: "-8px",
                  backgroundColor: "#10b981",
                  color: "white",
                  fontSize: "11px",
                  fontWeight: "700",
                  padding: "4px 10px",
                  borderRadius: "12px",
                  boxShadow: "0 4px 12px rgba(16, 185, 129, 0.4)",
                }}
              >
                {t("Business") || "Business"}
              </div>
            </div>

            {/* Title */}
            <h2
              style={{
                fontSize: "28px",
                fontWeight: "700",
                color: "#1a1a1a",
                textAlign: "center",
                margin: "0 0 12px 0",
                letterSpacing: "-0.5px",
              }}
            >
              {t("WantYourOwnBusinessApp") || "Want Your Own Business?"}
            </h2>

            {/* Subtitle */}
            <p
              style={{
                fontSize: "16px",
                color: "#6b7280",
                textAlign: "center",
                margin: "0 0 32px 0",
                lineHeight: "1.6",
              }}
            >
              {t("DownloadNeholToremForBusinessOwners") ||
                "Download NeholTorem and start managing your barber shop today!"}
            </p>

            {/* Features List */}
            <div
              style={{
                backgroundColor: "#f9fafb",
                borderRadius: "16px",
                padding: "20px",
                marginBottom: "24px",
              }}
            >
              <h3
                style={{
                  fontSize: "16px",
                  fontWeight: "700",
                  color: "#1a1a1a",
                  margin: "0 0 16px 0",
                }}
              >
                {t("WhatsIncluded") || "What's Included:"}
              </h3>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px",
                }}
              >
                {[
                  {
                    icon: "📅",
                    text:
                      t("ManageAppointments") || "Manage appointments online",
                  },
                  {
                    icon: "👥",
                    text: t("TrackCustomers") || "Track your customers",
                  },
                  {
                    icon: "💰",
                    text: t("IncreaseRevenue") || "Increase your revenue",
                  },
                  {
                    icon: "📊",
                    text:
                      t("BusinessAnalytics") || "Business analytics & reports",
                  },
                ].map((feature, index) => (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                    }}
                  >
                    <span style={{ fontSize: "20px" }}>{feature.icon}</span>
                    <span
                      style={{
                        fontSize: "14px",
                        color: "#374151",
                        fontWeight: "500",
                      }}
                    >
                      {feature.text}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            {/* Download Buttons */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "12px",
              }}
            >
              {/* App Store Button */}
              <button
                onClick={() => {
                  // Replace with your actual App Store link
                  window.open(
                    "https://apps.apple.com/us/app/neholtorem/id6755939980",
                    "_blank"
                  );
                }}
                style={{
                  padding: "14px 20px",
                  borderRadius: "14px",
                  border: "2px solid #000000",
                  backgroundColor: "#000000",
                  color: "#ffffff",
                  fontSize: "15px",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "10px",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow =
                    "0 8px 24px rgba(0, 0, 0, 0.2)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <svg width="22" height="22" viewBox="0 0 24 24" fill="white">
                  <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
                </svg>
                <div style={{ textAlign: "left" }}>
                  <div style={{ fontSize: "10px", opacity: 0.8 }}>
                    {t("DownloadOnThe") || "Download on the"}
                  </div>
                  <div style={{ fontSize: "16px", fontWeight: "700" }}>
                    App Store
                  </div>
                </div>
              </button>

              {/* Google Play Button */}
              <button
                onClick={() => {
                  window.open(
                    "https://play.google.com/store/apps/details?id=com.mohammad1998a.NeholTorem",
                    "_blank"
                  );
                }}
                style={{
                  padding: "14px 20px",
                  borderRadius: "14px",
                  border: "2px solid #000000",
                  backgroundColor: "#000000",
                  color: "#ffffff",
                  fontSize: "15px",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "10px",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow =
                    "0 8px 24px rgba(0, 0, 0, 0.2)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <svg width="22" height="22" viewBox="0 0 24 24" fill="white">
                  <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z" />
                </svg>
                <div style={{ textAlign: "left" }}>
                  <div style={{ fontSize: "10px", opacity: 0.8 }}>
                    {t("GetItOn") || "GET IT ON"}
                  </div>
                  <div style={{ fontSize: "16px", fontWeight: "700" }}>
                    Google Play
                  </div>
                </div>
              </button>
            </div>

            {/* Call to Action */}
            <div
              style={{
                marginTop: "24px",
                padding: "16px",
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                borderRadius: "12px",
                textAlign: "center",
              }}
            >
              <p
                style={{
                  fontSize: "13px",
                  color: "#ffffff",
                  margin: 0,
                  lineHeight: "1.5",
                  fontWeight: "500",
                }}
              >
                💼{" "}
                {t("JoinThousandsOfBarbers") ||
                  "Join thousands of barbers managing their business with NeholTorem"}
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Floating Business Button */}
      <button
        onClick={() => setShowDownloadModal(true)}
        style={{
          position: "fixed",
          bottom: "90px",
          right: "20px",
          padding: "14px 20px",
          borderRadius: "50px",
          border: "none",
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          color: "#ffffff",
          fontSize: "14px",
          fontWeight: "700",
          cursor: "pointer",
          boxShadow: "0 8px 24px rgba(102, 126, 234, 0.4)",
          zIndex: 9999,
          display: "flex",
          alignItems: "center",
          gap: "8px",
          transition: "all 0.3s ease",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-4px)";
          e.currentTarget.style.boxShadow =
            "0 12px 32px rgba(102, 126, 234, 0.5)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow =
            "0 8px 24px rgba(102, 126, 234, 0.4)";
        }}
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="white"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
          <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
        </svg>
        {t("ForBusinessOwners") || "For Business Owners"}
      </button>

      {/* Main Content Container */}
      <div style={{ position: "relative", zIndex: 1 }}>
        {/* Hero Section with Barber Info */}
        <MPHomeFirstBlock />

        {/* Content Wrapper */}
        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            padding: "0 16px",
            paddingBottom: "100px",
          }}
        >
          {/* Gallery Section */}
          <section
            style={{
              backgroundColor: "#ffffff",
              borderRadius: "24px",
              boxShadow: "0 2px 12px rgba(0, 0, 0, 0.08)",
              marginTop: "-40px",
              position: "relative",
              zIndex: 2,
              overflow: "hidden",
              border: "1px solid rgba(0, 0, 0, 0.04)",
            }}
          >
            <MPHomeShowImages />
          </section>

          {/* Booking Section */}
          {AllowUsersBookApp === 1 ? (
            <section
              style={{
                backgroundColor: "#ffffff",
                borderRadius: "24px",
                boxShadow: "0 2px 12px rgba(0, 0, 0, 0.08)",
                marginTop: "24px",
                padding: "32px 24px",
                position: "relative",
                border: "1px solid rgba(0, 0, 0, 0.04)",
              }}
            >
              {/* Section Header */}
              <div
                style={{
                  marginBottom: "24px",
                  paddingBottom: "16px",
                  borderBottom: "2px solid #f0f0f0",
                }}
              >
                <h2
                  style={{
                    fontSize: "22px",
                    fontWeight: "700",
                    color: "#1a1a1a",
                    margin: "0 0 8px 0",
                    letterSpacing: "-0.5px",
                  }}
                >
                  {t("BookYourAppointment")}
                </h2>
                <p
                  style={{
                    fontSize: "14px",
                    color: "#6b7280",
                    margin: 0,
                    fontWeight: "400",
                  }}
                >
                  {t("ChoosePreferredDateTime")}
                </p>
              </div>

              <MPHomeBookApp />
            </section>
          ) : (
            <section
              style={{
                backgroundColor: "#ffffff",
                borderRadius: "24px",
                boxShadow: "0 2px 12px rgba(0, 0, 0, 0.08)",
                marginTop: "24px",
                padding: "48px 32px",
                position: "relative",
                border: "1px solid rgba(0, 0, 0, 0.04)",
                textAlign: "center",
              }}
            >
              {/* Icon */}
              <div
                style={{
                  width: "80px",
                  height: "80px",
                  margin: "0 auto 24px",
                  background:
                    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  borderRadius: "20px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 8px 24px rgba(102, 126, 234, 0.25)",
                }}
              >
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                  <line x1="16" y1="2" x2="16" y2="6" />
                  <line x1="8" y1="2" x2="8" y2="6" />
                  <line x1="3" y1="10" x2="21" y2="10" />
                </svg>
              </div>

              {/* Title */}
              <h2
                style={{
                  fontSize: "24px",
                  fontWeight: "700",
                  color: "#1a1a1a",
                  margin: "0 0 12px 0",
                  letterSpacing: "-0.5px",
                }}
              >
                {t("OnlineBookingComingSoon")}
              </h2>

              {/* Description */}
              <p
                style={{
                  fontSize: "16px",
                  color: "#6b7280",
                  margin: "0 0 32px 0",
                  lineHeight: "1.6",
                  maxWidth: "500px",
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
              >
                {/* {t("BarberStopDescription")} */}
              </p>

              {/* Divider */}
              <div
                style={{
                  width: "60px",
                  height: "2px",
                  backgroundColor: "#e5e7eb",
                  margin: "0 auto 32px",
                  borderRadius: "2px",
                }}
              />

              {/* Contact Options */}
              <div style={{ marginBottom: "16px" }}>
                <p
                  style={{
                    fontSize: "15px",
                    fontWeight: "600",
                    color: "#374151",
                    margin: "0 0 20px 0",
                  }}
                >
                  {t("InTheMeantime")}
                </p>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "12px",
                    flexWrap: "wrap",
                  }}
                >
                  {/* SMS Button */}
                  <button
                    style={{
                      padding: "12px 24px",
                      borderRadius: "12px",
                      border: "2px solid #667eea",
                      backgroundColor: "#ffffff",
                      color: "#667eea",
                      fontSize: "14px",
                      fontWeight: "600",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#667eea";
                      e.currentTarget.style.color = "#ffffff";
                      e.currentTarget.style.transform = "translateY(-2px)";
                      e.currentTarget.style.boxShadow =
                        "0 4px 12px rgba(102, 126, 234, 0.3)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "#ffffff";
                      e.currentTarget.style.color = "#667eea";
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "none";
                    }}
                  >
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                    </svg>
                    {t("SMS")}
                  </button>

                  {/* Phone Button */}
                  <button
                    style={{
                      padding: "12px 24px",
                      borderRadius: "12px",
                      border: "2px solid #667eea",
                      backgroundColor: "#ffffff",
                      color: "#667eea",
                      fontSize: "14px",
                      fontWeight: "600",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#667eea";
                      e.currentTarget.style.color = "#ffffff";
                      e.currentTarget.style.transform = "translateY(-2px)";
                      e.currentTarget.style.boxShadow =
                        "0 4px 12px rgba(102, 126, 234, 0.3)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "#ffffff";
                      e.currentTarget.style.color = "#667eea";
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "none";
                    }}
                  >
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                    </svg>
                    {t("PhoneCall")}
                  </button>

                  {/* WhatsApp Button */}
                  <button
                    style={{
                      padding: "12px 24px",
                      borderRadius: "12px",
                      border: "2px solid #25D366",
                      backgroundColor: "#ffffff",
                      color: "#25D366",
                      fontSize: "14px",
                      fontWeight: "600",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#25D366";
                      e.currentTarget.style.color = "#ffffff";
                      e.currentTarget.style.transform = "translateY(-2px)";
                      e.currentTarget.style.boxShadow =
                        "0 4px 12px rgba(37, 211, 102, 0.3)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "#ffffff";
                      e.currentTarget.style.color = "#25D366";
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "none";
                    }}
                  >
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                    >
                      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                    </svg>
                    {t("WhatsApp")}
                  </button>
                </div>
              </div>
            </section>
          )}
        </div>

        {/* Premium Footer */}
        <footer
          style={{
            marginTop: "60px",
            padding: "40px 16px",
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            position: "relative",
            overflow: "hidden",
            paddingBottom: 120,
          }}
        >
          {/* Reviews Section */}
          {AllData?.allReviews && AllData.allReviews.length > 0 && (
            <section
              style={{
                backgroundColor: "#ffffff",
                borderRadius: "24px",
                boxShadow: "0 2px 12px rgba(0, 0, 0, 0.08)",
                marginTop: "24px",
                padding: "32px 24px",
                position: "relative",
                border: "1px solid rgba(0, 0, 0, 0.04)",
                marginBottom: "40px",
              }}
            >
              {/* Section Header */}
              <div
                style={{
                  marginBottom: "24px",
                  paddingBottom: "16px",
                  borderBottom: "2px solid #f0f0f0",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                    gap: "16px",
                  }}
                >
                  <div>
                    <h2
                      style={{
                        fontSize: "22px",
                        fontWeight: "700",
                        color: "#1a1a1a",
                        margin: "0 0 8px 0",
                        letterSpacing: "-0.5px",
                      }}
                    >
                      {t("CustomerReviews") || "Customer Reviews"}
                    </h2>
                    <p
                      style={{
                        fontSize: "14px",
                        color: "#6b7280",
                        margin: 0,
                        fontWeight: "400",
                      }}
                    >
                      {t("SeeWhatOurCustomersSay") ||
                        "See what our customers say about us"}
                    </p>
                  </div>

                  {/* Average Rating Display */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                      padding: "12px 20px",
                      background:
                        "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                      borderRadius: "16px",
                      boxShadow: "0 4px 12px rgba(102, 126, 234, 0.25)",
                    }}
                  >
                    <div style={{ textAlign: "center" }}>
                      <div
                        style={{
                          fontSize: "28px",
                          fontWeight: "700",
                          color: "#ffffff",
                          lineHeight: "1",
                        }}
                      >
                        {calculateAverageRating()}
                      </div>
                      <div
                        style={{
                          fontSize: "11px",
                          color: "rgba(255,255,255,0.9)",
                          marginTop: "4px",
                        }}
                      >
                        {t("OutOf") || "out of"} 5
                      </div>
                    </div>
                    <div>
                      {renderStars(
                        Math.round(parseFloat(calculateAverageRating()))
                      )}
                      <div
                        style={{
                          fontSize: "12px",
                          color: "rgba(255,255,255,0.9)",
                          marginTop: "4px",
                        }}
                      >
                        {AllData.allReviews.length} {t("Reviews") || "reviews"}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Reviews Grid */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
                  gap: "20px",
                }}
              >
                {AllData.allReviews.map((review) => (
                  <div
                    key={review.id}
                    style={{
                      padding: "20px",
                      backgroundColor: "#f9fafb",
                      borderRadius: "16px",
                      border: "1px solid #e5e7eb",
                      transition: "all 0.3s ease",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-4px)";
                      e.currentTarget.style.boxShadow =
                        "0 8px 24px rgba(0, 0, 0, 0.1)";
                      e.currentTarget.style.borderColor = "#667eea";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "none";
                      e.currentTarget.style.borderColor = "#e5e7eb";
                    }}
                  >
                    {/* User Info */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "start",
                        marginBottom: "12px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "12px",
                        }}
                      >
                        {/* User Avatar */}
                        <div
                          style={{
                            width: "48px",
                            height: "48px",
                            borderRadius: "12px",
                            background:
                              "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#ffffff",
                            fontSize: "18px",
                            fontWeight: "700",
                          }}
                        >
                          {review.userName.charAt(0).toUpperCase()}
                        </div>

                        <div>
                          <div
                            style={{
                              fontSize: "16px",
                              fontWeight: "600",
                              color: "#1a1a1a",
                              marginBottom: "2px",
                            }}
                          >
                            {review.userName}
                          </div>
                          <div style={{ fontSize: "12px", color: "#6b7280" }}>
                            {review.date} • {review.time}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Rating */}
                    <div style={{ marginBottom: "12px" }}>
                      {renderStars(review.rating)}
                    </div>

                    {/* Comment */}
                    {review.comment && (
                      <p
                        style={{
                          fontSize: "14px",
                          color: "#374151",
                          lineHeight: "1.6",
                          margin: 0,
                          fontStyle: review.comment ? "normal" : "italic",
                        }}
                      >
                        {review.comment ||
                          t("NoComment") ||
                          "No comment provided"}
                      </p>
                    )}
                  </div>
                ))}
              </div>
            </section>
          )}
          {/* Decorative elements */}
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background:
                "radial-gradient(circle at 20% 50%, rgba(255,255,255,0.1) 0%, transparent 50%)",
              pointerEvents: "none",
            }}
          />

          <div
            style={{
              maxWidth: "1200px",
              margin: "0 auto",
              position: "relative",
              zIndex: 1,
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "24px",
              }}
            >
              {/* Brand Section */}
              <div style={{ textAlign: "center" }}>
                <div>
                  <div
                    style={{
                      width: "100%",
                      height: "calc(50vh - 55px)",
                      padding: 20,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                        justifyContent: "center",
                        marginBottom: 20,
                      }}
                    >
                      <a
                        style={{
                          fontSize: 20,
                          fontWeight: "bold",
                        }}
                      >
                        {t("Chooselanguage")}
                      </a>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                      }}
                    >
                      <p
                        style={{
                          margin: 5,
                          padding: 0,
                          fontSize: 18,
                          color: Lang === "he" ? "black" : "#a1a1aa",
                          cursor: "pointer",
                          fontWeight: Lang === "he" ? "bold" : "",
                        }}
                        onClick={() => {
                          setChoosing(lang);
                          setLang("he");
                          changeLanguage("he");
                          localStorage.setItem("lang", JSON.stringify("he"));
                        }}
                      >
                        עברית
                      </p>
                      <p
                        style={{
                          margin: 5,
                          padding: 0,
                          fontSize: 18,
                          cursor: "pointer",
                          color: Lang === "ar" ? "black" : "#a1a1aa",
                          fontWeight: Lang === "ar" ? "bold" : "",
                        }}
                        onClick={() => {
                          setChoosing(lang);
                          setLang("ar");
                          changeLanguage("ar");
                          localStorage.setItem("lang", JSON.stringify("ar"));
                        }}
                      >
                        العربية
                      </p>
                      <p
                        style={{
                          margin: 5,
                          padding: 0,
                          fontSize: 18,
                          cursor: "pointer",
                          color: Lang === "en" ? "black" : "#a1a1aa",
                          fontWeight: Lang === "en" ? "bold" : "",
                        }}
                        onClick={() => {
                          setChoosing(lang);
                          setLang("en");
                          changeLanguage("en");
                          localStorage.setItem("lang", JSON.stringify("en"));
                        }}
                      >
                        English
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    fontSize: "28px",
                    fontWeight: "700",
                    color: "#ffffff",
                    letterSpacing: "1px",
                    marginBottom: "8px",
                    textShadow: "0 2px 4px rgba(0,0,0,0.1)",
                  }}
                >
                  NeholTorem
                </div>
                <div
                  style={{
                    fontSize: "15px",
                    color: "rgba(255,255,255,0.9)",
                    fontWeight: "400",
                  }}
                >
                  {t("ModernBookingSolutions")}
                </div>
              </div>

              {/* Divider */}
              <div
                style={{
                  width: "60px",
                  height: "2px",
                  backgroundColor: "rgba(255,255,255,0.3)",
                  borderRadius: "2px",
                }}
              />

              {/* Copyright */}
              <div
                style={{
                  fontSize: "13px",
                  color: "rgba(255,255,255,0.8)",
                  textAlign: "center",
                }}
              >
                {t("Copyright")}
              </div>
            </div>
          </div>
        </footer>
      </div>

      <MPHomeModalMakeApp />

      {/* Add CSS animation for modal */}
      <style>{`
        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
}
